@if(person(); as person){
<div class="parent-grid">

	<div class="bg-light rounded shadow-sm p-2">
		<table class='pro-table pro-table-no-background pro-table-with-labels pro-table-without-border'>
			<tr>
				<td>Name</td>
				<td>{{person.general.fullName}} <i class="fa-light fa-pencil ps-1" (click)="openNameEditor()"></i></td>
			</tr>
			<tr>
				<td>Address</td>
				<td>{{person.location?.address ?? 'N/A'}} <i class="fa-light fa-pencil ps-1" (click)="openAddressEditor()"></i></td>
			</tr>
			<tr>
				<td>Preferred Contact Method</td>
				<td>
					<span>{{person.contactMethod}}</span>
					<i class="fa-light fa-pencil ps-1" (click)="openContactMethodEditor()"></i>
				</td>
			</tr>
			<tr>
				<td>Phone</td>
				<td>
					{{person.phone}} ({{person.phoneType}})
					<i class="fa-light fa-pencil ps-1" (click)="openPhoneEditor()"></i>
				</td>
			</tr>
		</table>

		<div class="mt-3">
			<p class="mb-1">
				Do Not Contact Flag is <b>{{person.general.doNotContactNote ? 'ON' : 'OFF'}}</b>
				<i class="fa-light fa-pencil ps-2" (click)="editDoNotContact()"></i>
			</p>
			@if(person.general.doNotContactNote; as doNotContactNote){
			<p>Note: {{person.general.doNotContactNote}}</p>
			}
		</div>
	</div>

	<div class="secondary-grid h-100">
		<div class="bg-light rounded shadow-sm d-flex flex-column justify-content-between p-2">
			<div>
				<h5>Emails</h5>
				<p>{{person.general.primaryEmail}} <span class="ps-2">(primary)</span></p>
				@for(email of person.otherEmails; track email.emailId){
				<div class="d-flex align-items-center justify-content-between mb-2">
					<div>{{email.email}}</div>

					<common-button-row [center]="true" class="gap-1">
						<button class="btn btn-standard" (click)="setPrimaryEmail(email.emailId, email.email)">Make Primary</button>
						<button class="btn btn-standard" (click)="deleteEmail(email.emailId, email.email)"><i class="fa-light fa-trash"></i></button>
					</common-button-row>
				</div>
				}
			</div>

			<div>
				@if(emailErrorMsg(); as error){
				<div class="color-darkred text-center mb-2" style="font-size: 14px">{{ error }}</div>
				}
				<common-button-row [center]="true">
					<button class="btn btn-standard" (click)="addEmail()">Add Email</button>
				</common-button-row>
			</div>
		</div>

		<div class="bg-light rounded shadow-sm d-flex flex-column justify-content-between p-2">
			<div>
				<h5>Web Links</h5>
				<div>
					@for(webLink of person.general.webLinks; track webLink.webLinkId){
					<div class="d-flex align-items-center gap-2 justify-content-between mb-2">
						<div>
							<i class="pe-1" [class]="linkIconByType[webLink.webLinkTypeId]"></i>
							<a [href]="webLink.url" target="_blank">{{webLink.url}}</a>
						</div>

						<common-button-row [center]="true" class="gap-1">
							<button class="btn btn-standard"><i class="fa-light fa-pencil" (click)="addOrUpdateWebLink(webLink)"></i></button>
							<button class="btn btn-standard"><i class="fa-light fa-trash" (click)="deleteWebLink(webLink)"></i></button>
						</common-button-row>
					</div>
					}
				</div>
			</div>

			<div>
				<common-button-row [center]="true">
					<button class="btn btn-standard" (click)="addOrUpdateWebLink()">Add Web Link</button>
				</common-button-row>
			</div>
		</div>
	</div>

</div>
}